import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import posthog from 'posthog-js';
import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapOnboardingStore from '../../../../stores/useMapOnboardingStore';
import { useOnboardingState } from '../../../../hooks/useOnboardingState';

/**
 * First-visit zoom hint (`firstVisitPhase === 'zoom_hint'`); the welcome modal
 * opens the moment it fades out.
 */
export default function FirstVisitZoomHost() {
  const { t } = useTranslation();
  const openModal = useMapModalStore((s) => s.openModal);
  const firstVisitPhase = useMapOnboardingStore((s) => s.firstVisitPhase);
  const setFirstVisitPhase = useMapOnboardingStore((s) => s.setFirstVisitPhase);
  const { hasTapOnboardingDone } = useOnboardingState();

  // The phase lives in a global store: if the player leaves the map mid-hint,
  // it must not resume (and open a stale welcome modal) on their next visit.
  useEffect(() => () => setFirstVisitPhase(null), [setFirstVisitPhase]);

  return (
        <>
        {/* First-visit zoom hint — phase-driven, no timers */}
        {firstVisitPhase === 'zoom_hint' && (
          <>
            <style>{`@keyframes zoomHintFade { 0% { opacity: 0 } 8% { opacity: 1 } 88% { opacity: 1 } 100% { opacity: 0 } }`}</style>
            <div
              onAnimationEnd={() => {
                // Welcome modal right as the hint fades out — no extra pause.
                setFirstVisitPhase(null);
                if (hasTapOnboardingDone() || useMapModalStore.getState().activeModal !== null) return;
                openModal('mapWelcome');
                posthog.capture('onboarding_map_welcome_shown');
              }}
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 10000,
                pointerEvents: "none",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
                animation: "zoomHintFade 4s forwards",
              }}
            >
              <p
                style={{
                  fontFamily: "Lato, sans-serif",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "22px",
                  letterSpacing: "-0.747px",
                  color: "#FFF",
                  textAlign: "center",
                  margin: 0,
                  textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
                }}
              >
                {t("On the map you can use zoom")}
              </p>
              <img
                src="/ui/world-map/zoom-is-possible.gif"
                alt="Zoom hint"
                style={{
                  maxWidth: "210px",
                  maxHeight: "210px",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
          </>
        )}
        </>
  );
}
